<div class="pricelists-list-layout">
  <mat-form-field appearance="outline" class="searchbar">
    <input matInput placeholder="Cerca cliente, contratto, prodotto...">
    <div matSuffix class="search-icon-wrapper">
      <i class="fa-regular fa-magnifying-glass"></i>
    </div>
  </mat-form-field>
  
  <mat-chip-listbox class="chip-list" aria-label="Filtri listini">
    <!-- TODO: Collegare chiamata api per generare le voci -->
    <mat-chip-option>Tutti (6)</mat-chip-option>
    <mat-chip-option>Attivi (3)</mat-chip-option>
    <mat-chip-option>In approvazione (2)</mat-chip-option>
    <mat-chip-option>In scadenza (1)</mat-chip-option>
    <mat-chip-option>Scaduti (1)</mat-chip-option>
  </mat-chip-listbox>
  
  <div class="elements-container">
    @for (item of mockItems; track item.id) {
      <div class="element">
      <!-- NB: Disabilitato router temporaneamente per nascondere dettaglio, al momento vuoto -->
      <!-- <div class="element" routerLink="/pricelists/detail"> -->
        <div class="content">
          <div class="body-medium">{{ item.numeroContratto }}</div>
          <div class="body-medium-emphasized">{{ item.cliente }}</div>
          <div class="body-small">
            {{ item.inizio | translocoDate: { dateStyle: 'long' } }} →
            {{ item.fine | translocoDate: { dateStyle: 'long' } }} ·
            {{ item.righe }} righe ·
            {{ item.agente }}
          </div>
        </div>
      
        <div class="badge">
          <span [class]="'status-badge status-' + item.stato + ' body-medium-emphasized'">
            {{ statusLabels[item.stato] }}
          </span>
        </div>
      </div>
    
      @if (!$last) {
        <mat-divider class="element-divider"></mat-divider>
      }
    }
  </div>
</div>
